import { DataFormat } from "utils/format/DataFormat";
export abstract class TransactionHistoryRequestModel {
  status?: number;
  code?: string;
  carrier?: Array<string>;
  phoneNumber?: string;
  page?: number;
  limit?: number;
  pagination?: boolean;
  fromDate?: string;
  type?: number;
  partner?: string;
  partnerCode?: string;
  toDate?: string;
  storeCode?: string;
  staff?: Array<string>;
  isOnlyStore?: string;
  isdnOrIccid?: string;
  created?: Array<Record<string, unknown>>;
  order?: string;
  constructor(data?: Partial<TransactionHistoryRequestModel>) {
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.type = data?.type;
    this.partner = data?.partner;
    this.partnerCode = data?.partnerCode;
    this.storeCode = data?.storeCode;
    this.staff = data?.staff;
    this.isOnlyStore = data?.isOnlyStore;
    this.isdnOrIccid = data?.isdnOrIccid;
    this.created = data?.created;
    this.order = data?.order;
  }

  public removeUnknowValue?<T extends TransactionHistoryRequestModel>(data: T) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>,
    );
  }
}
